import { format, isValid, parseISO } from 'date-fns';
import { ISO_DATE_FORMAT } from '@/configs';
import { FilterInput } from '../../constants';

export function parseFilterDate(value: string): Date | null {
  if (!value) return null;
  const parsed = parseISO(value);
  return isValid(parsed) ? parsed : null;
}

export function formatFilterDate(value: Date | null): string {
  if (!value || !isValid(value)) return '';
  return format(value, ISO_DATE_FORMAT);
}

export function getNonEmptyFilters(filters: FilterInput[]) {
  return filters.filter(({ operator, value }) => operator || value);
}
